module.exports = __webpack_public_path__ + "img/kim_tunesien_strand_ocular.1e4a20a3.jpg";